<div class="container-margin">
  <form [formGroup]="importForm">
    <h2>{{ translationService.getImportIngredientsText() }}</h2>
    <div class="form-groups">
      <p>
        {{ translationService.getIngredientCsvTemplateSelectionMessage() }}
      </p>
      <div class="form-group template-name-field">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getCsvTemplateNameText()
          }}</mat-label>
          <mat-select formControlName="template">
            @for (template of templates; track template) {
              <mat-option [value]="template.id">{{
                template.templateName
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <p>
        {{ translationService.getIngredientImportFilesMessage() }}
      </p>
      <div class="form-group">
        <mat-label>{{
          translationService.getIngredientImportFileText()
        }}</mat-label>
        <input
          type="file"
          (change)="onFileChange($event, 'ingredientImportFile')"
          #ingredientImportFile
          accept=".csv"
        />
      </div>
    </div>
  </form>

  <div class="actions margin-top-10">
    <button
      mat-stroked-button
      extended
      color="primary"
      class="action-item"
      (click)="reset()"
    >
      <mat-icon>refresh</mat-icon>
      {{ translationService.getResetText() }}
    </button>
    <button
      mat-raised-button
      extended
      color="primary"
      class="action-item"
      (click)="onSubmit()"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.getImportText() }}
    </button>
  </div>
</div>
